import { type StepEntry } from 'customer-flows/components/_config/registry'

export default [
  {
    type: 'FlowConfigDateStep',
    componentPath: 'booking/date-picker',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingStartPage'],
    imposesQuoteRequirement: 'availability:selectedDate'
  },
  {
    type: 'FlowConfigTicketStep',
    componentPath: 'booking/ticket-picker',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingStartPage']
  },
  {
    type: 'FlowConfigTimeStep',
    componentPath: 'booking/time-picker',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingStartPage'],
    imposesQuoteRequirement: 'availability:selectedAvailabilityTime'
  },
  {
    type: 'FlowConfigSeatMapsStep',
    componentPath: 'booking/seat-maps',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingStartPage']
  },
  {
    type: 'FlowConfigDurationStep',
    componentPath: 'booking/duration-picker',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingStartPage'],
    imposesQuoteRequirement: 'availability:selectedAvailabilityDuration'
  },
  {
    type: 'FlowConfigBundleStep',
    componentPath: 'booking/bundle',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingUpsellsPage']
  },
  {
    type: 'FlowConfigCustomerInfoStep',
    componentPath: 'booking/customer-info',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingInfoPage']
  },
  {
    type: 'FlowConfigCustomQuestionsStep',
    componentPath: 'booking/custom-question',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingInfoPage', 'FlowConfigBookingConfirmationPage']
  },
  {
    type: 'FlowConfigPaymentStep',
    componentPath: 'booking/payment',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingPaymentPage']
  },
  {
    type: 'FlowConfigTippingStep',
    componentPath: 'booking/tips',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingPaymentPage']
  },
  {
    type: 'FlowConfigPeekProtectStep',
    componentPath: 'booking/peek-protect',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingPaymentPage']
  },
  {
    type: 'FlowConfigConfirmationStep',
    componentPath: 'booking/confirmation',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingConfirmationPage']
  },
  {
    type: 'FlowConfigBookingPortalStep',
    componentPath: 'booking/booking-portal',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingConfirmationPage']
  },
  {
    type: 'FlowConfigTilesStep',
    componentPath: 'tiles',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigTilesPage']
  },
  {
    type: 'FlowConfigExtensionStep',
    variant: 'DEFAULT'
  },
  {
    type: 'FlowConfigRelatedBookingFlowsStep',
    componentPath: 'related-booking-flows',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingStartPage']
  }
] satisfies StepEntry[]
